import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { XsI18nPipe } from './xs-i18n.pipe';

@Pipe({
  name: 'xsFileSizeFormatPipe',
})
export class FileSizeFormatPipe implements PipeTransform {
  constructor(private xsI18nPipe: XsI18nPipe, private decimalPipe: DecimalPipe) {}

  transform(fileSize: number): any {
    if (fileSize < 1024 * 1024) {
      let fileSizeInKB = fileSize / 1024;
      if (fileSizeInKB > 0 && fileSizeInKB < 1) {
        fileSizeInKB = 1;
      }
      return this.xsI18nPipe.transform(
        'fileSizeFormatFilter_KB_Caption',
        this.decimalPipe.transform(fileSizeInKB, '1.0-0')
      );
    } else {
      const fileSizeInMB = fileSize / 1024 / 1024;
      return this.xsI18nPipe.transform(
        'fileSizeFormatFilter_MB_Caption',
        this.decimalPipe.transform(fileSizeInMB, '1.2-2')
      );
    }
  }
}
